import React from 'react';
import ReactDOM from 'react-dom';
//import ProgressProvider from "../../ProgressProvider";
import './Profile.css';
import iconPath from "./../../../helpers/iconHelper";
import { getlanguagelist } from "../../../helpers/changelanguage";
import {encrypt} from "../../../helpers/CryptoJs";
import { Link } from 'react-router-dom';

import {
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
//import "react-circular-progressbar/dist/styles.css";

const Profile = ({profile_percentage,profile_image,total_post,total_friend,membership,userId}) => { 
    
   
    let  languagelist = getlanguagelist();
    const CircularProgressbarStyle = {
      // Customize the root svg element
      root: {},
      // Customize the path, i.e. the "completed progress"
      path: {
        // Path color
        
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'round',
        // Customize transition animation
        transition: 'stroke-dashoffset 0.5s ease 5s',
        // Rotate the path
        transform: 'rotate(0.25turn)',
        transformOrigin: 'center center',
      },
      // Customize the circle behind the path, i.e. the "total progress"
      trail: {
        // Trail color
        stroke: '#d6d6d6',
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'butt',
        // Rotate the trail
        transform: 'rotate(0.25turn)',
        transformOrigin: 'center center',
      },
      // Customize the text
      text: {
        // Text color
        fill: '#f88',
        // Text size
        fontSize: '16px',
      },
      // Customize background - only used when the `background` prop is true
      background: {
        fill: '#3e98c7',
      },
    };

    const redirectto = () => {
      props.history.push(`/user/${encrypt(userId)}`);
      
    }
    return (
        <div className="post_box known text-center">
            <h4>{languagelist.profilecompletion}  {profile_percentage}% </h4>
            <div style={{ width: "110px", margin: "10px auto" }}>
              <CircularProgressbarWithChildren value={profile_percentage} strokeWidth={2} styles={CircularProgressbarStyle}>
                <div className="header_pic" >
                    <Link to={ `/user/${encrypt(userId)}`}>
                    {
                        (profile_image != '') ? 
                        <img className={(membership == 'GOLD') ? "gold_user" : ""} style={{ width: 90, marginTop: -35, height: 90, marginLeft: -28 , objectFit : 'cover'}} src={profile_image} alt="doge"/> : 
                        <img className={(membership == 'GOLD') ? "gold_user" : ""} style={{ width: 90, marginTop: -35, height: 90, marginLeft: -28, objectFit : 'cover' }} src={iconPath['DEFAULTUSER']} alt="doge"/>
                    }
                    </Link>
                </div>
              </CircularProgressbarWithChildren>
            </div>
            <div className="post_box_footer">
                    <div className="row">
                        <div className="col-lg-5"><p><strong>{total_friend}</strong> <br/>{languagelist.friends} </p></div>
                        <div className="col-lg-2"><p>|</p> </div>
                        <div className="col-lg-5"><p><strong>{total_post}</strong>   <br/>{languagelist.posts}</p> </div>
                    </div>
            </div> 
        </div>
    );
};
export default Profile;